import React from "react";
import { Link } from "react-router-dom";

import styles from "./AnchorButton.module.scss";

const AnchorButton = ({
  children,
  to: linkTo,
  onClick,
  primary: isPrimary,
  ...rest
}) => {
  return (
    <Link
      to={linkTo}
      className={`${styles.base} ${isPrimary ? styles.primary : ""} ${
        rest.className ? rest.className : ""
      }`}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default AnchorButton;
